import * as React from 'react';
import { Field } from 'redux-form';
import {
  FormStyled,
  Error,
  Link,
  LinkWrapper
} from '../Form/styled';

import { Button } from '@app/src/components/Button';

import { RenderInput } from '@app/src/views/Login/RenderInput';
import { required, email } from '@app/src/utils/validations';

export const Form = ({
  handleSubmit,
  errorMessage,
  isFetching,
  handleClick
}) => (
  <FormStyled data-test="loginForm" onSubmit={handleSubmit}>
    <Error data-test="errorMessage">{errorMessage}</Error>
    <Field
      name="username"
      type="text"
      label="Usuario"
      component={RenderInput}
      validate={[required, email]}
    />
    <Field
      name="password"
      type="password"
      label="Contraseña"
      component={RenderInput}
      validate={[required]}
    />
    <Button data-test="btnLogin" type="submit" primary fullWidth loading={isFetching}>Ingresar</Button>
    <LinkWrapper >
      <Link data-test="forgetPassword" onClick={handleClick} >¿Olvidaste tu contraseña?</Link>
    </LinkWrapper>
  </FormStyled>
);
